export enum KeyboardKeys {
    Enter = 'Enter',
    ArrowDown = 'ArrowDown',
    ArrowUp = 'ArrowUp'
}